import React, { Suspense } from 'react';
import { Route, useLocation } from 'react-router-dom'
import { BackgroundTypeEnum, BackgroundPositionEnum } from '../components/base/BackgroundsEnum'
import { useSelector } from 'react-redux';
import { matchPath } from 'react-router'
import Constants from '../constants/Constants';
import { LanguageService } from '../services/LanguageService';
import Utils from '../services/Utils';
import { RoutePath } from '../constants/SitePaths';
import { Browser } from '../services/helpers/Browser';
import StylesHelper from '../services/helpers/StylesHelper';
import UrlHelper from '../services/helpers/UrlHelper';
import RestrictionType from '../constants/Enums/RestrictionEnum';
const SeoContent = React.lazy(() => import('../components/base/SeoContent'));

/* Full Screen Layout */

export const FullScreenLayout = ({ children, ...rest }) => {
  const { seoRulesEnabled, restrictionType } = useSelector((state) => state.settings);
  const { pathname } = useLocation()
  const matchWidgetPath = matchPath(pathname, { path: `/${LanguageService.getSelectedLanguage()}${RoutePath.WIDGET_EDITOR}` })
  const matchPaymentPath = matchPath(pathname, { path: `/${LanguageService.getSelectedLanguage()}${RoutePath.PAYMENT_SUBMIT}` })
  const isNotWidgetPreview = !(Utils.isPreviewMode() && matchWidgetPath)
  const showSeoContent = (restrictionType !== RestrictionType.FullBlock && seoRulesEnabled && isNotWidgetPreview && rest.alias !== Constants.GAME_INFO && !matchPaymentPath && !Browser.isMobileApp())

  const bodyBg = rest.pageBgData && rest.pageBgData.filter(data => data.backgroundType === BackgroundTypeEnum.Body).filter(element => {
    return element.forAllPages === true ? element : element.pages.filter(el => el.alias === rest.alias) && element.pages.filter(el => el.alias === rest.alias).length ? element : null;
  });

  const bodyBgPosition = rest.pageBgData && rest.pageBgData.filter(data => data.backgroundType === BackgroundTypeEnum.Body).filter(element => {
    return element.forAllPages === true ? element : element.pages.filter(el => el.alias === rest.alias) && element.pages.filter(el => el.alias === rest.alias).length ? element : null;
  });

  const background = bodyBg && bodyBg[0];

  let mainStyle = {};
  if (background) {
    const bgImg = background.imageUrl ? background.imageUrl : UrlHelper.getStaticFileUrl(`/img/backgrounds/${background.id}${background.extension}?v=${background.lastModifiedDate}`);
    mainStyle = { backgroundImage: `url("${bgImg}")` };
  }

  return (
    <React.Fragment>
      <div
        className={`wrapper wrapper-full-screen ${bodyBg && bodyBg.length ? StylesHelper.getBgSize(bodyBg) : ''}
       ${bodyBg && bodyBg.length && bodyBg[0].backgroundPosition === BackgroundPositionEnum.Fixed ? 'wrapper-img_fixed' : ''}`}
        style={mainStyle}>
        {children}
        <div>
          {showSeoContent && <Suspense fallback={<></>}><SeoContent alias={rest.alias} /></Suspense>}
        </div>
      </div>
    </React.Fragment>
  )
}

/*
  Private route wrapper
 */

export const FullScreenRoute = ({ component: Component, isSettingsLoading, language, placeholder: PlaceHolder, ...rest }) => {
  return (
    <Route {...rest} render={matchProps => (
      <FullScreenLayout key={language}>
        {(isSettingsLoading || !language) && PlaceHolder ? <PlaceHolder /> :
          <Suspense fallback={PlaceHolder ? <PlaceHolder /> : <></>}>
            <Component {...matchProps} />
          </Suspense>}
      </FullScreenLayout>
    )} />
  )
};

